module.exports = __webpack_public_path__ + "img/header-logo.05771dc9.svg";